import { useParams } from 'react-router-dom';
import MonetizationForm from '../components/monetization/MonetizationForm';

const MonetizationEdit = () => {
  const { id } = useParams<{ id: string }>();
  const operationType = new URLSearchParams(window.location.search).get('operation_type') || 'cheque';

  return <MonetizationForm mode="edit" id={id} operationType={operationType} saveBeforeExecute={true} />;
};

export default MonetizationEdit;
